export default "__VITE_ASSET__CQmKRuZS__"